import { makeStyles } from '@material-ui/core/styles';
import { headerHeight } from 'config';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    const isLightMode = theme.palette.type === Theme.Light;
    return {
        root: {
            backgroundColor: isLightMode ? 'rgb(255,255,255)' : 'rgb(40,40,40)',
        },
        wrapper: {
            display: 'flex',
            height: '100%',
            flex: '1 1 auto',
            [theme.breakpoints.up('sm')]: {
                paddingTop: headerHeight,
            },
        },
        content: {
            width: '100%',
            flex: '1 1 auto',
        },
        main: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: `calc(var(--vh, 1vh) * 100 - ${headerHeight}px)`,
        },
    };
});
